// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Button, { ButtonPresentationProps } from "@conklin/MobiusOverrides/Button/Button";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState, isCartEmpty } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const cart = getCurrentCartState(state).value;
    return {
        cartPageLink: getPageLinkByPageType(state, "CartPage")?.url,
        cart,
        isCartEmpty: isCartEmpty(cart),
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface OnePageCheckoutConfirmationReturnToCartStyles {
    wrapper?: InjectableCss;
    returnToCartText?: TypographyPresentationProps;
    returnToCartButton?: ButtonPresentationProps;
}

export const OnePageCheckoutConfirmationReturnToCartStyles: OnePageCheckoutConfirmationReturnToCartStyles = {};

const styles = OnePageCheckoutConfirmationReturnToCartStyles;

const OnePageCheckoutConfirmationReturnToCart: FC<Props> = ({ cartPageLink, isCartEmpty, history }) => {
    if (isCartEmpty) {
        return null;
    }

    const returnToCartClickHandler = () => {
        cartPageLink && history.push(cartPageLink);
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.returnToCartText}>
                {siteMessage("Custom_OrderConfirmation_ReturnToCartText")}
            </Typography>
            <Button {...styles.returnToCartButton} onClick={returnToCartClickHandler}>
                {translate("Return to Your Cart")}
            </Button>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(OnePageCheckoutConfirmationReturnToCart)),
    definition: {
        displayName: "Order Confirmation return to Cart",
        allowedContexts: ["OnePageCheckoutConfirmationPage"],
        fieldDefinitions: [],
        group: "Order Confirmation",
    },
};

export default widgetModule;
